import {createIdentityVerificationSvg as Icon__small__createIdentityVerificationSvg} from '../Icon__small/Icon__small--createIdentityVerification.js'

export var createIdentityVerification = {
  name: 'createIdentityVerification',
  category: 'icon',
  colorable: true,
  svg: Icon__small__createIdentityVerificationSvg,
};
